/*eslint-disable */
define(function(require) {
    var $           = require('jquery');
    var _           = require('underscore');
    var Backbone    = require('backbone');
    var config      = require('common/page-config');
    var events      = require('common/event-aggregator');
    var accountInfo = require('site/common/user/account-information');
    var PaymentsCollection      = require('common/collection/customer-stored-payments');
    var DiscountsCollection     = require('common/collection/account-discounts');
    var AuthenticatedCustomer   = require('common/model/authenticated-customer');
    var AccountRainbow          = require('common/model/account-rainbow').default;

    var Account = Backbone.Model.extend(
    // Instance members and methods
    {
        isLoggedIn: function() {
            var loginStatus = this.get('loginStatus');
            return loginStatus === 'PROFILE_AUTHENTICATED' || loginStatus === 'ACCOUNT_AUTHENTICATED';
        },

        /**
         * Is the login valid for checkout?
         *
         * @returns Boolean
         */
        isLoginValidForCheckout: function() {
            if (!this.isLoggedIn()) {
                return false;
            }
            if (this.storedPayments.length === 0) {
                return true;
            }
            return !this.get('authenticationExpired');
        },

        isRecognized: function() {
            var email = this.get('email');
            return typeof email === 'string' && email.length > 0;
        },

        logout: function() {
            var promise = $.post('/ajax/site/logout/');

            promise.done(function onLoggedOut() {
                events.trigger(events.PROFILE_LOGOUT);
                accountInfo.refresh();
            });

            return promise;
        }
    },
    // Static class methods
    {
        /**
         * Login the Account with given credentials.
         *
         * This includes the following: Logging in, fetching the account data,
         * fetching stored payments, creating model and triggering event.
         *
         * The promise is resolved and success event triggered by passing in the
         * Account model.
         *
         * @return Promise jqXHR
         */
        login: function login(email, password, facebookAccessToken, persistentLogin, includeStoredPayments) {
            var drd = $.Deferred();

            function onResponse(data) {
                /* Deliberate split of header name */
                if (this.xhrRequest.getResponseHeader("X-Acc" + "ount") === "Limited") {
                  data.result = "RATE_LIMITED";
                }

                if (data.result === 'PROFILE_AUTHENTICATED' || data.result === 'ACCOUNT_AUTHENTICATED') {
                    accountInfo.refresh();
                    this._getAccountData(events.PROFILE_LOGIN, data, includeStoredPayments)
                    .then(onLoaded, onError);
                } else if(data.result === 'CHANNEL_MISMATCH') {
                    events.trigger(events.PROFILE_LOGIN_FAILURE_CHANNEL);
                    drd.reject();
                } else if(data.result === 'REQUIRES_PASSWORD_VERIFICATION') {
                    events.trigger(events.PROFILE_LOGIN_FAILURE_REQUIRES_PASSWORD_VERIFICATION);
                    drd.reject();
                } else if(data.result === 'FACEBOOK_AND_NO_PASSWORD') {
                    events.trigger(events.PROFILE_LOGIN_FAILURE_FACEBOOK_AND_NO_PASSWORD, data.requestPasswordToken);
                    drd.reject();
                } else if (data.result === "REQUIRES_RESET" || data.result === "LOCKED") {
                    events.trigger(events.PROFILE_REQUIRES_RESET, data.result);
                    drd.reject();
                } else if (data.result === "RATE_LIMITED") {
                    events.trigger(events.PROFILE_RATE_LIMITED, data.result);
                    drd.reject();
                } else {
                    events.trigger(events.PROFILE_LOGIN_FAILURE);
                    drd.reject();
                }
            }
            function onError() {
                events.trigger(events.PROFILE_LOGIN_ERROR);
                // TODO: is more information required? This is a server error.
                drd.reject();
            }
            function onLoaded(accountModel) {
                drd.resolve(accountModel);
            }

            Account
                ._login(email, password, facebookAccessToken, persistentLogin)
                .then(_.bind(onResponse, this), _.bind(onError, this));

            return drd.promise();
        },

        /**
         * Load all Account data (including stored payment and discount codes).
         *
         * @return Promise jqXHR
         */
        load: function _getExtendedAccountData(refresh, includeStoredPayments) {
            return this._getAccountData(events.PROFILE_AVAILABLE, refresh, includeStoredPayments);
        },

        _getAccountData: function _getExtendedAccountData(doneEvent, refresh, includeStoredPayments) {
            var discounts = new DiscountsCollection;
            var authenticatedCustomer = new AuthenticatedCustomer();
            var payments = new PaymentsCollection;
            var accountRainbow = new AccountRainbow();
            var deferred = new $.Deferred();

            if (refresh) {
                accountInfo.refresh();
            }

            accountInfo.get().done(function(account) {
                var accountModel = new Account(account);

                if (accountModel.isLoggedIn()) {

                    var xhrList;
                    var discountsXhr                = discounts.fetch();
                    var authenticatedCustomerXhr    = authenticatedCustomer.fetch();
                    var accountRainbowXhr           = accountRainbow.fetch();

                    xhrList = [
                        discountsXhr,
                        authenticatedCustomerXhr,
                        accountRainbowXhr,
                    ];

                    if (includeStoredPayments){
                        xhrList.push(payments.fetch());
                    }

                    $.when.apply($, xhrList)
                    .then(function() {
                        accountModel.discounts = discounts;
                        accountModel.authenticatedCustomer = authenticatedCustomer;
                        accountModel.storedPayments = payments;
                        accountModel.isNewsLetterEnabled = accountRainbow.get("isNewsLetterEnabled");
                        accountModel.venueCommunicationSettings = accountRainbow.get("venueCommunicationSettings");
                        events.trigger(doneEvent, accountModel);
                        deferred.resolve(accountModel);
                    }).
                    fail(function(xhr, reason, message) {
                        console.warn(reason, message);
                    });
                } else {
                    events.trigger(doneEvent, accountModel);
                    deferred.resolve(accountModel);
                }
            });

            return deferred;
        },

        /**
         * Does the actual POST for login.
         *
         * @return Promise jqXHR
         */
        _login: function _login(email, password, facebookAccessToken, persistentLogin) {
            this.xhrRequest = $.ajax({
                type: 'post',
                url: '/ajax/site/login',
                data: {
                    email               : email,
                    password            : password,
                    facebookAccessToken : facebookAccessToken,
                    persistentLogin     : !!persistentLogin
                }
            });

            return this.xhrRequest;
        },

        /**
         * Set the account image to one of avatars.
         *
         * @param int
         *            avatarImageId
         * @return Promise
         */
        setAvatarImageId: function(avatarImageId) {
            var uri = '/ajax/account/image';
            var deferred = $.when(
                $.ajax({
                    url : uri,
                    data: { avatarImageId: avatarImageId },
                    type: 'PUT'
                })
            );
            deferred.done(function() {
                events.trigger(events.PROFILE_IMAGE_CHANGED, { isAvatar: true });
            });
            return deferred.promise();
        }
    });

    return Account;
});
